import Constants from '../services/Constants';
import User from '../services/User';

export const INIT_INTERVENTION_FILTERS = {
  advisor: [],
  carBrand: [],
  interventionStatus: [],
  origins: [],
  showArchived: false,
  showOnlyMine: false,
  type: [],
};

export const INIT_INTERVENTION_PAGINATION = {
  currentPageSize: 10,
  totalElements: 10,
}

export const getInterventionInitFiltersWithUser = () => ({
  ...INIT_INTERVENTION_FILTERS,
  origins: User.isCallCenterAgent() ? Constants.ORIGIN_CALL_CENTER.value : undefined,
});
